"use strict";
require('../skills/CompanySkillsService.js');

CompanyObjectSkillsCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$q',
  'growl',
  '$translate',
  'CompanyObjectSkillsService',
  'object',
  'objectType',
  'skills'
];

function CompanyObjectSkillsCtrl(
  $scope,
  $stateParams,
  $q,
  growl,
  $translate,
  CompanyObjectSkillsService,
  object,
  objectType,
  skills) {

  $scope.skills = skills;
  angular.forEach($scope.skills, function(skill){
    var objectSkillC = $scope.objectSkills.filter(function(item){
      return skill.id === item.skill.id;
    })[0];
    if(objectSkillC){
      skill.selected = true;
      skill.endDate = objectSkillC.endDate;
    }
  });

  $scope.saveObjectSkills = function() {
    $q.all(
      angular.forEach($scope.skills, function(skill){
        var objectSkill = $scope.objectSkills.filter(function(item){
          return skill.id === item.skill.id;
        })[0];
        if(skill.selected){
          if(!objectSkill){
            CompanyObjectSkillsService.save({companyId: $scope.companyId}, {
              skill: {id: skill.id, name: skill.name},
              endDate: skill.endDate,
              object: {id: object.id, name: object.name},
              objectType: objectType
            }, function(res){
              $scope.objectSkills.push(res);
            });
          }else{
            CompanyObjectSkillsService.update({companyId: $scope.companyId, objectSkillId: objectSkill.id}, {
              skill: {id: skill.id, name: skill.name},
              endDate: skill.endDate,
              object: {id: object.id, name: object.name},
              objectType: objectType,
              id: objectSkill.id
            });
            $scope.objectSkills[$scope.objectSkills.indexOf(objectSkill)].endDate = skill.endDate;
          }
        }
        if(!skill.selected && objectSkill){
          CompanyObjectSkillsService.delete({companyId: $scope.companyId, objectSkillId: objectSkill.id}, function(){
            $scope.objectSkills.splice($scope.objectSkills.indexOf(objectSkill), 1);
          });
        }
      })
    ).then(function(){
        growl.addSuccessMessage($translate.instant('skills.save-success'));
        $scope.$hide();
    }, function(){
      growl.addErrorMessage($translate.instant('skills.save-failure'));
    });
  };

}

angular.module('dokiv')
  .controller('CompanyObjectSkillsCtrl', CompanyObjectSkillsCtrl);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/object-skills/CompanyObjectSkillsCtrl.js
// module id = 366
// module chunks = 0